// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"81dfe519","169":"9e6f18a0","260":"ca1193c7","284":"e61b693c","744":"b486be5b"}[chunkId] + ".chunk.css";
};